import { Component, DoCheck, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { filter, takeUntil, tap } from 'rxjs/operators';

import { AuthService } from 'src/app/core/authentication/auth.service';
import { UserInfo } from 'src/app/core/authentication/UserInfo';
import { CanDeactivateState } from 'src/app/core/guards/can-deactivate.guard';
import { LanguageService } from 'src/app/service/language.service';
import { StagingMandateStateService } from 'src/app/core/mandates-api/staging-mandate-state.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, DoCheck, OnDestroy {
  isAuthenticated: boolean;
  userInfo: UserInfo | undefined

  private destroy$ = new Subject<void>();

  constructor(
    private authService: AuthService,
    private languageService: LanguageService,
    private stagingMandateStateService: StagingMandateStateService,
    readonly router: Router
  ) {
    window.onpopstate = () => (CanDeactivateState.defendAgainstBrowserBackButton = true);

    router.events
      .pipe(
        filter((e) => e instanceof NavigationEnd),
        tap(() => (CanDeactivateState.defendAgainstBrowserBackButton = false)),
        takeUntil(this.destroy$)
      )
      .subscribe();
  }

  ngDoCheck() {
    const userContainerWidth = document.getElementById('userContainer')?.offsetWidth as number;
    const elements = document.querySelectorAll('.mat-menu-panel,.userMenu');
    elements.forEach((element) => {
      if (element instanceof HTMLElement) element.style.width = userContainerWidth - 4 + 'px';
    });
  }

  async ngOnInit() {
    this.languageService.use(this.languageService.getBrowserLanguage());

    this.authService.isAuthenticated$
      .pipe(takeUntil(this.destroy$))
      .subscribe((value) => (this.isAuthenticated = value));

    this.authService.userInfo$
      .pipe(
        tap(value => (this.userInfo = value)),
        filter(userInfo => !!userInfo),
        takeUntil(this.destroy$),
      )
      .subscribe(() => this.stagingMandateStateService.requestIndicators());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
